import { valibotResolver } from "@hookform/resolvers/valibot";
import { PencilSimpleLine } from "@phosphor-icons/react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import useCustomer from "common/datahooks/useCustomer";
import { HTTPError } from "common/helpers/HTTP";
import { EmailSchema } from "common/schemas";

import SettingsItemContainer from "../SettingsItemContainer";

export default function Email() {
  const [isEditing, setIsEditing] = useState(false);
  const {
    updateCustomer,
    isCustomerUpdating,
    customerInfo,
    updateCustomerError,
    resetUpdateCustomer,
  } = useCustomer();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<{
    email: string;
  }>({
    resolver: valibotResolver(EmailSchema),
    defaultValues: {
      email: customerInfo.email,
    },
  });

  async function onSubmit({ email }: { email: string }) {
    if (customerInfo.email !== email) {
      await updateCustomer({ email });
    }
    setIsEditing(false);
  }
  function onCancel() {
    setIsEditing(false);
    reset({ email: customerInfo.email });
  }

  let errorMessage: string;

  if (updateCustomerError) {
    if (
      updateCustomerError instanceof HTTPError &&
      updateCustomerError.type === "Conflict:"
    ) {
      errorMessage = "Email already exists";
    } else {
      errorMessage = "Error updating email, please try again later";
    }
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <SettingsItemContainer className="items-center">
        {isEditing ? (
          <FormField
            label="Email address"
            htmlFor="emailField"
            size="sm"
            className="flex-1"
            error={errorMessage || errors.email?.message}
          >
            <div className="flex">
              <Input
                placeholder="New email address"
                id="emailField"
                variant="sm"
                className="w-80"
                {...register("email", { onChange: resetUpdateCustomer })}
              />
              <div className="flex gap-x-2 mt-auto ml-auto">
                <Button
                  variant="secondary-black"
                  type="button"
                  size="sm"
                  onClick={onCancel}
                  disabled={isCustomerUpdating}
                >
                  Cancel
                </Button>
                <Button size="sm" type="submit" isLoading={isCustomerUpdating}>
                  Save
                </Button>
              </div>
            </div>
          </FormField>
        ) : (
          <>
            <div className="flex flex-col gap-y-0.5">
              <span className="text-sm-bold">Email address</span>
              <span className="text-black-500 text-xs-medium">
                {customerInfo.email}
              </span>
            </div>
            <Button
              variant="ghost-black"
              intent="iconOnly"
              className="ml-auto"
              onClick={() => setIsEditing(true)}
            >
              <PencilSimpleLine />
            </Button>
          </>
        )}
      </SettingsItemContainer>
    </form>
  );
}
